import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAeNNC0tSJr1ONgMUHMKxzsz13NGBbgfSo",
  authDomain: "nascomdiscovery.firebaseapp.com",
  projectId: "nascomdiscovery",
  storageBucket: "nascomdiscovery.firebasestorage.app",
  messagingSenderId: "368529018873",
  appId: "1:368529018873:web:c3c19c2c2ca0914027f728"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);